import { useState, useEffect } from 'react';
import { TemplateFbIg, tChangeChatStateRequest } from '../../../../Chat.types';
import { ChatService } from '../../../../Chat.service';

export const useTemplatesActions = () => {
  const [templates, setTemplates] = useState<TemplateFbIg[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTemplates = async () => {
    setLoading(true);
    setError(null);
    try {
      const templatesFbIgResponse = await ChatService.getTemplatesFbIg();
      setTemplates(templatesFbIgResponse);
    } catch (err: unknown | string | undefined) {
      setError((err as Error).message || 'Error fetching templates');
    } finally {
      setLoading(false);
    }
  };

  const changeChatState = async (
    workspaceId: string,
    handle: string,
    request: tChangeChatStateRequest,
  ) => {
    try {
      await ChatService.changeChatState(workspaceId, handle, request);
      return true;
    } catch (err: unknown | string | undefined) {
      setError((err as Error).message || 'Error changing state');
      return false;
    }
  };

  // Automatically call fetchTemplates on mount
  useEffect(() => {
    fetchTemplates();
  }, []);

  return {
    templates,
    loading,
    error,
    refetch: fetchTemplates,
    changeChatState,
  };
};
